import React, { useState } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BrandForm from "./brand-form"
import {
  Col,
  Container,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import { PageTitle } from "constants/ui"
import { getTabNames, getTabPermissions } from "helpers/tab_helper"
import PermissionTabs from "components/Common/PermissionTabs"

const BrandDetail = props => {
  document.title = PageTitle.BRAND_DETAIL

  const [activeTab, setactiveTab] = useState("1")

  const tabNames = getTabNames("BRAND_DETAIL")
  const tabPermissionsArray = getTabPermissions("BRAND_DETAIL", "detail")

  const toggle = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            titleLink="/brands"
            title={PageTitle.BRAND_LIST}
            breadcrumbItem={PageTitle.BRAND_DETAIL}
          />
          <Row>
            <Col md="6">
              <PermissionTabs
                tabs={tabNames}
                activeTab={activeTab}
                onTabChange={toggle}
                tabPermissions={tabPermissionsArray}
                history={props.history}
              />

              <TabContent activeTab={activeTab} className="p-3 text-muted">
                <TabPane tabId="1">
                  <BrandForm page="add" {...props} />
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BrandDetail